module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1788921444950.png";